<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template>
          <!-- <template v-slot:default="{ open }"> -->
          <v-row no-gutters v-if="quot">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{
                  formatDate(quot.cargo.tentativeDate)
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{
                  quot.expireAt | moment("HH:MM DD MMM")
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{
                  quot.cargo.clientName
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{
                  quot.cargo.material
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{
                  quot.cargo.truckType
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" class="body-2">{{
                  quot.cargo && quot.cargo.src
                    ? quot.cargo.src.city +
                      (quot.cargo.src.state ? ", " + quot.cargo.src.state : "")
                    : ""
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" class="body-2">{{
                  quot.cargo && quot.cargo.dst
                    ? quot.cargo.dst.city +
                      (quot.cargo.dst.state ? ", " + quot.cargo.dst.state : "")
                    : ""
                }}</v-col>
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="1"
                  lg="1"
                  class="body-2 text-right"
                  >{{ quot.wishPrice }}</v-col
                >
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" class="body-2">
                  <z-confirm-button
                    class="float-right"
                    color="red lighten-1"
                    small
                    fab
                    text
                    dark
                    :message="$i18n.t('Do you want to reject this quot ?')"
                    @click="rejectQuot(quot)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </z-confirm-button>
                  <!-- <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="float-right"
                        color="primary"
                        small
                        fab
                        text
                        dark
                        @click="giveQuotation(quot)"
                        v-on="on"
                      >
                        <v-icon>mdi-chat</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>-->
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="pr-2 pl-2">
        <v-row no-gutters v-if="quot">
          <v-col cols="12" md="6" v-if="bid" class="pr-2 pl-2">
            <v-row>
              <v-list-item-content calss="px-3">
                <v-row>
                  <v-col cols="12" md="4" class="mx-3">
                    <h3>{{ $i18n.t("Fare Items") }}</h3>
                  </v-col>
                  <v-spacer />
                  <v-col cols="12" md="4">
                    <v-btn
                      class="float-left"
                      v-if="
                        !bid ||
                          !bid.fare ||
                          !bid.fare.charges ||
                          bid.fare.charges.length == 0
                      "
                      @click="bid.fare.charges = newItem(bid.fare.charges)"
                      small
                      style="width:60px;float:right;"
                      color="light-blue"
                      text
                    >
                      <v-icon>mdi-plus</v-icon>
                      <h3>{{ $i18n.t("Add") }}</h3>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-content>
              <v-row>
                <v-col
                  v-for="(item, index) in bid.fare.charges"
                  :key="'item' + index"
                  cols="12"
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  class="pa-0 ma-0"
                >
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="item.name"
                        :label="$i18n.t('Name')"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="item.desc"
                        :label="$i18n.t('Descriptin')"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="item.amount"
                        :label="$i18n.t('Amount')"
                        type="number"
                      />
                    </v-col>
                    <v-col cols="12" md="3" class="text-left">
                      <v-btn
                        class="float-left"
                        color="error"
                        small
                        fab
                        text
                        dark
                        @click="remove(bid.fare.charges, index)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-btn
                        class="float-left"
                        v-if="index + 1 == bid.fare.charges.length"
                        @click="bid.fare.charges = newItem(bid.fare.charges)"
                        small
                        style="width:60px;float:right;"
                        color="light-blue"
                        text
                      >
                        <v-icon>mdi-plus</v-icon>
                        <h3>{{ $i18n.t("Add") }}</h3>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-row>
          </v-col>
          <v-col cols="12" md="3" v-if="bid" class="pr-2 pl-2">
            <v-row>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="bid.comment"
                  :label="$i18n.t('Add Comment')"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-btn
                  color="success"
                  class="mr-0 float-right"
                  small
                  dark
                  @click="saveBid()"
                  :loading="loading"
                >
                  <v-icon>mdi-gavel</v-icon>
                  &nbsp;
                  {{ $i18n.t("Submit Bid") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="3" v-if="bid" class="pr-2 pl-2">
            <v-simple-table>
              <thead>
                <tr>
                  <th class="primary--text">{{ $i18n.t("Comment") }}</th>
                  <th class="primary--text">{{ $i18n.t("By") }}</th>
                  <th class="primary--text">{{ $i18n.t("At") }}</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(c, index) in bid.commentTOS" :key="index">
                  <td>{{ c.msg }}</td>
                  <td>{{ c.commentBy }}</td>
                  <td>{{ c.at | moment("DD MMM YYYY hh:mm a") }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "QuotRequestROw",
  props: {
    value: {
      default: null,
    },
    refresh: {
      default: null,
    },
    _filterFor: {
      default: null,
    },
  },
})
export default class QuotRequestRow extends Vue {
  quot = null;
  bid = null;

  get loading() {
    return common.loading;
  }

  async mounted() {
    if (this.value) {
      this.quot = this.value;
      this.bid = this.quot ? this.quot.bid : { fare: {} };
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.quot = val;
    this.bid = this.quot ? this.quot.bid : { fare: {} };
  }

  rejectQuot() {
    this.$emit("rejectQuot", this.quot);
  }

  // async giveQuotation(quot) {
  //   this.bid = null;
  //   this.quot = null;
  //   try {
  //     common.setLoading(true);
  //     const response = await doGet("/api/bid/quot/" + quot._id + "/detail");
  //     this.bid = response;
  //     this.quot = quot;
  //     common.setLoading(false);
  //   } catch (e) {
  //     common.setError(e.message);
  //     common.setLoading(false);
  //   }
  // }

  async saveBid() {
    try {
      common.setLoading(true);
      await doPost("/api/bid/quot/" + this.quot._id + "/save", this.bid);
      common.showMessage("Bid saved succesfully.");
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>
<style scoped>
/deep/ .v-btn--fab.v-size--small {
  height: 20px;
  width: 20px;
}
</style>
